import {BaseModel} from '../../../shared/models/base-model.model';

export class RegionalCore extends BaseModel {
  regionalId: string;
  regionalNombre: string;
  regionalVisible: boolean;
  Usuarios: RegionalUsuarioCore[] = [];
}

export class RegionalUsuarioCore extends BaseModel {
  usuarioId: string;
  usuarioCorreoInstitucional: string;
}

export function nameRegionalCore(regional: RegionalCore): string {
  return `${regional.regionalNombre}`;
}

export function numberRegionalCore(regional: RegionalCore): string {
  return `${regional.regionalId}`;
}
